export function headers(url?: string, header:string = 'application/json') {
    const h: any = {
        Accept: header,
    };

    if (url !== '/login_check' && localStorage.getItem('access_token')) {
        h.AuthorizationJWT = localStorage.getItem('access_token');
    }

    return h;
}
